import "@/styles/globals.css";
import Layout from "@/components/layout";
import { DefaultSeo } from "next-seo";
import { AnimatePresence, m } from "framer-motion";
import { LazyMotion, domAnimation } from "framer-motion";
import { SingleModalProvider } from "@/components/contexts";
// import { Partytown } from "@builder.io/partytown/react";
// import { GoogleAnalytics, GoogleTagManager } from "@next/third-parties/google";
// import Script from "next/script";
export default function App({ Component, pageProps, router }) {
  return (
    <AnimatePresence mode="wait">
      <SingleModalProvider>
        {/* <Partytown debug={true} forward={["dataLayer.push"]} /> */}
        <LazyMotion features={domAnimation}>
          <DefaultSeo
            title="Soul Scale | Consulting that Strengthens the Development Sector — Finance, Research and Climate Solutions for Informal Workers"
            defaultTitle="Soul Scale | Consulting that Strengthens the Development Sector — Finance, Research and Climate Solutions for Informal Workers"
            description="Soulscale, the consulting arm of Jan Sahas, helps development organisations strengthen financial systems, ensure statutory compliance, and resolve complex challenges. Focus on driving impact—we’ll take care of your financial management."
            canonical="https://soulscale.org"
            openGraph={{
              url: "https://soulscale.org",
              title: "Soul Scale",
              description:
                "Soulscale, the consulting arm of Jan Sahas, helps development organisations strengthen financial systems, ensure statutory compliance, and resolve complex challenges. Focus on driving impact—we’ll take care of your financial management.",
              images: [
                {
                  url: "https://soulscale.org/soul-scale-512x512.webp",
                  width: 140,
                  height: 140,
                  alt: "Soul Scale",
                },
              ],
            }}
            twitter={{
              // handle: "@avneesh0612",
              // site: "@avneesh0612",
              cardType: "summary_large_image",
            }}
            additionalLinkTags={[
              {
                rel: "icon",
                href: `/favicon.ico`,
              },
              {
                rel: "apple-touch-icon",
                href: "/favicon.ico",
                sizes: "76x76",
              },
            ]}
          />
          <Layout>
            <m.div
              key={router.route}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.35 } }}
              exit={{ opacity: 0 }}
              className="h-auto w-full"
            >
              <Component {...pageProps} key={router.route} />

              {/* <GoogleTagManager gtmId="GTM-W2RR5JF" /> */}
            </m.div>
          </Layout>
        </LazyMotion>
      </SingleModalProvider>
    </AnimatePresence>
  );
}
